__turbopack_context__.v({
  "container": "TenantGate-module__FU5Inq__container",
  "content": "TenantGate-module__FU5Inq__content",
  "logoItem": "TenantGate-module__FU5Inq__logoItem",
  "logos": "TenantGate-module__FU5Inq__logos",
  "separator": "TenantGate-module__FU5Inq__separator",
  "topLeftGradient": "TenantGate-module__FU5Inq__topLeftGradient",
  "topRightGradient": "TenantGate-module__FU5Inq__topRightGradient",
});
